import get from 'lodash/get';

import { COMMUNITY_AUTHOR_ROLE } from '../../constants/strings';
import { COMMUNITIES_USER_ROLES } from '../../constants';

export default (author, formatMessage) => {
  if (get(author, 'role') === COMMUNITIES_USER_ROLES.MODERATOR) {
    return formatMessage(COMMUNITY_AUTHOR_ROLE.moderator);
  }

  return '';
};



// WEBPACK FOOTER //
// ./src/utils/communities/getModeratorTitle.js